import React, { useState } from "react";
import { sbGetSetting, sbSetSetting } from "../utils/supabaseClient";
import { sendNotification } from "../utils/notifications";
import "../styles/CreateTab.css";

const ResourceCreateTab = () => {
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [url, setUrl] = useState("");
  const [description, setDescription] = useState("");
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title.trim() || !url.trim()) {
      setMessage("Title and URL are required");
      return;
    }

    // Validate URL
    try {
      new URL(url);
    } catch {
      setMessage("Please enter a valid URL");
      return;
    }

    setSaving(true);
    try {
      const newResource = {
        id: `resource_${Date.now()}`,
        title: title.trim(),
        category: category.trim(),
        url: url.trim(),
        description: description.trim(),
        addedAt: new Date().toISOString(),
      };

      let resources = await sbGetSetting("origamic-resources");
      if (!Array.isArray(resources)) resources = [];

      resources.push(newResource);
      await sbSetSetting("origamic-resources", resources);

      // Send notification with AI-generated message
      await sendNotification(
        `NEW RESOURCE: ${title.trim()}`,
        description.trim() || url.trim(),
        "resources",
        newResource.id,
        { type: "resource", title: title.trim(), category: category.trim(), description: description.trim(), url: url.trim() }
      );

      setMessage("✅ Resource saved successfully!");
      setTitle("");
      setCategory("");
      setUrl("");
      setDescription("");

      setTimeout(() => setMessage(""), 3000);
    } catch (err) {
      console.error("Error saving resource:", err);
      setMessage("❌ Failed to save resource");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="create-container">
      <h2>Create New Resource</h2>

      <form onSubmit={handleSubmit} className="create-form">
        <div className="form-group">
          <label>Title *</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="e.g., AI Research Papers"
            disabled={saving}
          />
        </div>

        <div className="form-group">
          <label>Category</label>
          <input
            type="text"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            placeholder="e.g., Learning, Tools, Research"
            disabled={saving}
          />
        </div>

        <div className="form-group">
          <label>URL *</label>
          <input
            type="url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="https://example.com"
            disabled={saving}
          />
        </div>

        <div className="form-group">
          <label>Description</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Brief description of the resource..."
            rows="4"
            disabled={saving}
          />
        </div>

        <div className="form-actions">
          <button type="submit" className="btn-primary" disabled={saving}>
            {saving ? "Saving..." : "💾 Save Resource"}
          </button>
        </div>

        {message && (
          <div className={`message ${message.includes("✅") ? "success" : "error"}`}>
            {message}
          </div>
        )}
      </form>
    </div>
  );
};

export default ResourceCreateTab;
